import { useMemo } from 'react';
import FlywheelContactCardAction from './FlywheelContactCardAction';
import { jsx as _jsx } from "react/jsx-runtime";
export const FlywheelContactCardActionWrapper = behaviorArgs => {
  const {
    hasScope
  } = behaviorArgs;
  return useMemo(() => {
    const FlyWheelContactCardActionWithScopes = cardActionComponentProps => {
      const canAddContact = hasScope('bet-contact-creation-flow-access') && !hasScope('bet-cold-source-restriction');
      const otherProps = {
        hasRequiredScopes: canAddContact
      };
      return /*#__PURE__*/_jsx(FlywheelContactCardAction, Object.assign({}, cardActionComponentProps, otherProps));
    };
    return FlyWheelContactCardActionWithScopes;
  }, [hasScope]);
};